import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { LpPagination } from "~/design-system";
import { getPaginationWindow } from "~/utils/pagination";
export class listPagePagination_template extends vnTemplate {
    getTemplateHtml() {
        return `
            <input data-bind="value: pageNumber" type="hidden">
            ${LpPagination({
            firstAttributes: {
                title: "First page",
                "data-bind": "click: onClickPageFirst, css: { 'is-disabled': pageNumber() <= 1 }",
            },
            pageListAttributes: {
                "data-bind": "foreach: pages",
            },
            lastAttributes: {
                title: "Last page",
                "data-bind": "click: onClickPageLast, css: { 'is-disabled': pageNumber() >= pageMax() || pageMax() <= 1 }",
            },
        })}
        `;
    }
    getTemplateName() {
        return "list-page-pagination-template";
    }
    getMainElementClasses() {
        return ["w-pagination"];
    }
    buildViewModel() {
        const pagination = this;
        return {
            pageNumber: ko.observable(1),
            pageMax: ko.observable(1),
            pages: ko.observableArray([{ pageNumber: 1, isSelected: 1 }]),
            itemCount: function (data) { pagination.setNumberItemToPaginate(data); },
            itemPerPage: 25,
            reducedSidePages: false,
            onClickPageAction: function (data) { pagination.onClickPageAction(data.pageNumber); },
            onClickPageFirst: function (_data, event) {
                event?.preventDefault?.();
                pagination.onClickPageFirst();
                return false;
            },
            onClickPageLast: function (_data, event) {
                event?.preventDefault?.();
                pagination.onClickPageLast();
                return false;
            },
            reuseTotalCount: null,
        };
    }
    setNumberItemToPaginate(numberItemToPaginate) {
        const pagination = getPaginationWindow({
            itemCount: numberItemToPaginate,
            itemPerPage: this.viewModel[this.idElement].itemPerPage,
            pageNumber: this.viewModel[this.idElement].pageNumber(),
            reducedSidePages: this.viewModel[this.idElement].reducedSidePages,
        });
        this.viewModel[this.idElement].pages(pagination.pages);
        this.viewModel[this.idElement].pageMax(pagination.pageMax);
    }
    onClickPageAction(pageNumber) {
        this.filterList(pageNumber);
    }
    onClickPageFirst() {
        if (this.viewModel[this.idElement].pageNumber() <= 1) {
            return;
        }
        this.filterList(1);
    }
    onClickPageLast() {
        const pageMax = this.viewModel[this.idElement].pageMax();
        if (pageMax <= 1 || this.viewModel[this.idElement].pageNumber() >= pageMax) {
            return;
        }
        this.filterList(pageMax);
    }
    filterList(pageNumber) {
        this.viewModel[this.idElement].pageNumber(pageNumber);
        this.caller.paginationOnPageClick(this.idElement);
    }
}
